import React, {
    createContext,
    useMemo,
    useState,
    ReactNode,
} from 'react';
import { getNumberSeparators } from './utils';

interface NumberSeparators {
    thousandSeparator: string;
    decimalSeparator: string;
}

interface LocaleContextValue {
    locale: string;
    name: string;
    numberSeparators: NumberSeparators;
}

interface LocaleProviderProps {
    children?: ReactNode;
}

const defaultValue: Omit<LocaleContextValue, 'numberSeparators'> = {
    locale: 'de-CH',
    name: 'navigation',
};

const LocaleContext = createContext<LocaleContextValue>({
    ...defaultValue,
    numberSeparators: getNumberSeparators(defaultValue.locale),
});

const { Provider, Consumer: LocaleConsumer } = LocaleContext;

const LocaleProvider = ({ children }: LocaleProviderProps) => {
    const [locale] = useState(defaultValue);

    const numberSeparators = useMemo(
        () => getNumberSeparators(locale.locale),
        [locale.locale],
    );

    const value = useMemo<LocaleContextValue>(
        () => ({
            ...locale,
            numberSeparators,
        }),
        [locale, numberSeparators],
    );

    return <Provider value={value}>{children}</Provider>;
};

export {
    LocaleProvider,
    LocaleConsumer,
    LocaleContext,
};
